"use strict";

exports.__esModule = true;
exports.outlineParser = exports.outline = void 0;

var _core = require("../core");

var _utils = require("../utils");

/**
 * The parser configuration for common outline properties
 */
var config = {
  outline: true,
  outlineOffset: true,
  outlineColor: _utils.t.colors("outlineColor")
};
var outline = (0, _core.system)(config);
exports.outline = outline;
var outlineParser = (0, _core.createParser)(config);
exports.outlineParser = outlineParser;
//# sourceMappingURL=outline.js.map